import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import DatePicker from '../../app/components/date-picker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import _ from 'underscore';
import TextLinks from './daily/shared/daily-text-links';

dayjs.extend(customParseFormat);

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            vip: props.base_url.match(/vip/),
        };
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.logged_in != this.props.logged_in) {
            document.location.href = this.props.base_url;

            return true;
        } else if (nextProps.horoscope != this.props.horoscope) {
            if (nextProps.horoscope && !nextProps.horoscope.interp) {
                document.location.href = this.props.base_url;
            }

            return true;
        }

        return false;
    }

    render({ horoscope, slant, date, base_url }, { vip }) {
        if (horoscope && horoscope.interp) {
            const rowClass = vip
                ? 'is-aligned-center'
                : 'is-aligned-center has-margin-20-top has-margin-20-bottom';

            return (
                /* eslint-disable react/no-unknown-property */
                /* unknown-property: slant, date, base_url */
                <horoscope slant={slant} date={date} base_url={base_url}>
                    <row className={rowClass}>
                        {this.renderDateLinks(horoscope, date, base_url)}
                    </row>
                    {this.renderHeading()}
                    {this.renderHoroscope()}
                </horoscope>
                /* eslint-enable react/no-unknown-property */
            );
        }

        return (<horoscope {...this.props} />); //eslint-disable-line tarot/no-direct-props-access-in-render
    }

    renderDateLinks = (horoscope, date, base_url) => {
        let maxDate;
        let minDate;
        if (this.props.slant == 'weekly') {
            maxDate = dayjs().day(1).add(this.props.hide_next ? 6 : 13, 'day');
        } else {
            maxDate = this.props.hide_next ? dayjs() : dayjs().add(3, 'day');
        }

        if (this.props.hide_prev) {
            minDate = this.props.slant == 'weekly' ? dayjs().day(1) : dayjs();
        } else {
            minDate = this.props.slant == 'weekly' ? dayjs().day(1).subtract(1, 'week') : dayjs().subtract(90, 'day');
        }

        if (this.props.slant == 'monthly') {
            return (
                <column className='is-12 has-padding-10-left-mobile'>
                    <TextLinks
                        date={date}
                        base_url={`${base_url}/${horoscope.sign}`}
                    />
                </column>
            );
        }

        return [
            <column className='is-1'>
                <DatePicker
                    url={`${base_url}/${horoscope.sign}/:date`}
                    page={`${this.props.slant == 'weekly' && 'weekly-'}horoscope`}
                    mindate={minDate.format('YYYY-MM-DD')}
                    maxdate={maxDate.format('YYYY-MM-DD')}
                    date={dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD')}
                    autosubmit='true'
                />
            </column>,
            <column className='is-11 has-padding-10-left-mobile'>
                <TextLinks
                    date={date}
                    base_url={`${base_url}/${horoscope.sign}`}
                />
            </column>,
        ];
    }

    renderHeading = () => {
        const slant_headers = {
            generic: ' Daily Horoscope',
            love: ' Daily Love Horoscope',
            weekly: ' Weekly Love Horoscope',
            monthly: ' Monthly Horoscope',
        };
        const sign = this.props.horoscope.sign.charAt(0).toUpperCase() + this.props.horoscope.sign.slice(1);

        if (this.state.vip) {
            return [
                <h1>{sign} {slant_headers[this.props.slant]}</h1>,
                <div className='daily-links has-margin-15-bottom'>
                    <a
                        href={`/articles/bios/${this.props.horoscope.author_slug}`}
                        onClick={() => this.props.trackEvent([
                            'Daily Nav',
                            'Click',
                            `Text - by ${this.props.horoscope.author}`,
                            `Bio:${this.props.horoscope.author}`,
                        ])}
                    >
                        by {this.props.horoscope.author}
                    </a>
                </div>,
            ];
        }

        return (
            <row className='is-aligned-end has-margin-20-bottom'>
                <column className='is-9 has-padding-10-right'>
                    <h1
                        className='has-margin-0'
                        dangerouslySetInnerHTML={{
                            __html: sign + slant_headers[this.props.slant].replace(
                                /Daily/, 'Daily<br />'
                            ).replace(/Weekly/, 'Weekly<br />'),
                        }}
                    />
                </column>
                <column className='is-3 has-text-right'>
                    <a
                        className='daily-links has-text-color-black has-text-size-12'
                        href={`/articles/bios/${this.props.horoscope.author_slug}`}
                        onClick={() => this.props.trackEvent([
                            'Bio',
                            'Click',
                            this.props.horoscope.author,
                            `Bio:${this.props.horoscope.author}`,
                        ])}
                    >
                        by {this.props.horoscope.author}
                    </a>
                </column>
            </row>
        );
    }

    renderHoroscope = () => {
        let date_format = 'MMMM D, YYYY';
        let date_prefix = '';
        if (this.props.slant == 'monthly') {
            date_format = 'MMMM YYYY';
        } else if (this.props.slant == 'weekly') {
            date_format = 'dddd, MMMM D';
            date_prefix = 'Week of ';
        }

        return this.props.horoscope.interp.split('\n').map((p, key) => {
            if (key === 0) {
                return (
                    <p className='has-margin-10-top has-text-size-20 has-line-height-35'>
                        <b>{date_prefix + dayjs(this.props.horoscope.date, 'YYYY-M-D').format(date_format)}:</b>&nbsp;
                        {p}
                        {this.renderContinue()}
                    </p>
                );
            }

            return (<p className='has-text-size-20 has-line-height-35'>{p}</p>);
        });
    }

    renderContinue = () => {
        if (this.props.horoscope && this.props.horoscope.continue) {
            return (
                <a href={this.props.horoscope.continue}>Continue</a>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    horoscope: state.horoscope,
    logged_in: state.user && state.user.logged_in,
    user: state.user,
    product: state.product,
    slant: state.slant,
    hide_prev: state.hide_prev,
    hide_next: state.hide_next,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
